/***************/
/**  IMPORTS  **/
/***************/
import { useState, useEffect } from 'react';
import { toast, Toaster, ToastBar } from 'react-hot-toast';
import { Row } from "react-bootstrap";
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { ring } from 'ldrs';
import Cookies from "universal-cookie";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { get } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import AdminTableRow from '../components/AdminTableRow';
import admin from "../assets/admin.svg";
import { PageContainer,
         Header,
         Tab,
         } from "../styles/AdminPageStyles";

export default function AdminDashboardPage(){

    const cookies = new Cookies();
    const token = cookies.get("TOKEN");

    const [active, setActive] = useState("Accounts");
    const [loading, setLoading] = useState(true);
    const [rowsData, setRowsData] = useState([]);  // State to hold rows
    const [fetchRowsData, setFetchRowsData] = useState(null);

    Amplify.configure(amplifyconfig);
    ring.register();

    const fetchRows = async () => {
        setLoading(true);
        try{
            const account = get({
                apiName: 'UserAPI',
                    path: '/user/admin/get-all-user-info',
                    options: {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    }
            });
            const { body } = await account.response;
            const res = await body.json();

            console.log("Fetching user data GET call succeeded");
            const response = res.reverse();
            setFetchRowsData(response);
        } catch(e){
            console.log('User details GET call failed: ', e);
        } finally {
            setLoading(false);  // Ensure loading is set to false after try/catch
        }
    };

    useEffect(() => {
        if (active === "Accounts") {
            fetchRows();
        }
    }, [active])

    useEffect(() => {
        if(fetchRowsData){
            const rows = fetchRowsData.map((user) => {
                return <AdminTableRow key={user._id} user={user} fetchRows={fetchRows}/>;
            });
            setRowsData(rows);
        }
    }, [fetchRowsData]);


    const renderContent = () => {
        switch (active) {
            case "Accounts":
                return (
                    <MDBTable responsive="lg">
                        <MDBTableHead>
                            <tr>
                                <th scope='col' style={{ minWidth: '150px' }}>Name</th>
                                <th scope='col' style={{ minWidth: '100px' }}>Role</th>
                                <th scope='col' style={{ minWidth: '150px' }}>Email</th>
                                <th scope='col' style={{ minWidth: '150px' }}>Phone Number</th>
                                <th scope='col' style={{ minWidth: '150px' }}>Status</th>
                                <th scope='col' style={{ minWidth: '150px' }}>Account Created</th>
                                <th scope='col' style={{ minWidth: '150px' }}>Last Updated</th>
                                <th scope='col' style={{ minWidth: '20px' }}>Actions</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {loading ? (
                                <tr key="loading">
                                    <td colSpan="6" style={{ textAlign: 'center' }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "none" }}>
                                            <l-ring
                                                size="50"
                                                stroke="5"
                                                bg-opacity="0"
                                                speed="2"
                                                color="#616161"
                                                />
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                rowsData
                            )}
                        </MDBTableBody>
                    </MDBTable>);
            case "Locations":
                return null;
            default:
                return null;
        }
    };

    return (
        <>
        <Navbar />
        <Toaster 
            position='top-right'
            toastOptions={{
                className: '',
                style: {
                padding: '16px',
                color: '#205DBC',
                width: '400px',
                },
            }}>{(t) => (
                <ToastBar toast={t}>
                {({ icon, message }) => (
                    <>
                    {icon}
                    {message}
                    {t.type !== 'loading' && (
                        <button 
                        onClick={() => toast.dismiss(t.id)}
                        style={{border: "none", backgroundColor: "white", color: "#205DBC"}}>
                        X
                        </button>
                    )}
                    </>
                )}
                </ToastBar>
            )}</Toaster>
        <div style={{display: "flex", justifyContent: "center", flexDirection: "row", backgroundColor: "white", margin: "20px", borderRadius: "10px", paddingBottom: "150px"}}>
            <PageContainer>
                <div className="header" style={{display: "flex", flexDirection: "row"}}>
                    <Sidebar></Sidebar>
                    <img alt="notification_icon" src={admin} style={{marginLeft: 30, paddingTop: "5px"}} />
                    <Header>Admin Dashboard</Header>
                </div>
                <Row className="body" style={{display: "flex", justifyContent: "space-evenly", background: "none", marginBottom: "30px", height: "50px"}}>
                    <Tab
                        key="accounts"
                        active={active === "Accounts"}
                        onClick={() => setActive("Accounts")}>Accounts</Tab>
                    <Tab
                        key="locations"
                        active={active === "Locations"}
                        onClick={() => setActive("Locations")}>Locations</Tab>
                </Row>
                <Row style={{background:'none'}}>
                {renderContent()}
                </Row>
            </PageContainer>
        </div>
        </>
    )
}